import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { Col, Flex, Row, Typography, Section } from 'components';

import LivesCard from '../livesCard';
import { useSchool } from 'features/school';
import { LiveVideoCard } from 'app/types/cards/LiveVideoCard';

interface LivesListProps {
  lives: LiveVideoCard[];
  productClassUuid: string;
  enrolled: boolean;
}

const LivesList = ({ lives, productClassUuid, enrolled }: LivesListProps): ReactElement => {
  const { productSlug } = useParams();

  const { schoolUuid, schoolMelver } = useSchool();

  const schoolIsRC = schoolUuid === '27b0f3bc-c645-4463-a4d2-201577ede070';

  let livesHat = 'Aulas ao vivo';
  let livesTitle = 'Bate-papo com especialistas';

  if (productSlug === 'treinamento-ap-p') {
    livesHat = '';
    livesTitle = 'Convidados Especiais';
  }

  if (productSlug === 'fraternidade-melver') {
    livesHat = '';
    livesTitle = 'Encontros ao vivo';
  }

  if (productSlug === 'intromercadodeopcoes') {
    livesHat = 'Bônus';
    livesTitle = 'Aulas práticas';
  }

  if (schoolUuid === '14d970bd-3794-4268-bf67-2c5d2d0f0285' && productSlug === 'mestre-do-fluxo') {
    livesTitle = 'Acompanhamento Exclusivo';
  }

  if (schoolIsRC && productSlug === 'investimentos') {
    livesHat = '';
    livesTitle = 'Aulas ao vivo';
  }

  if (schoolMelver && (productSlug === 'o-grande-impacto' || productSlug === 'o-poder-das-opcoes')) {
    livesHat = '';
    livesTitle = 'Aulas práticas';
  }

  return (
    <Flex bg="gray_200" flexGrow={1}>
      <Section flexDirection="column" flexGrow={0}>
        <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0}>
          <Flex flexDirection="column" flexGrow={0}>
            {!!livesHat && (
              <Typography type="type3" color="dark_350" upper mb={2}>
                {livesHat}
              </Typography>
            )}

            <Typography type="type8" fontWeight="bold" color="dark_350">
              {livesTitle}
            </Typography>

            {/* {productSlug === 'na-rota-do-mercado-financeiro' && (
              <Typography type="type2" color="gray_600" mt={2}>
                Obs: em breve serão divulgadas as datas dos bate-papos com os convidados.
              </Typography>
            )} */}
          </Flex>
        </Flex>

        {Boolean(lives.length) ? (
          <Row gutter={20} flexGrow={0}>
            {lives.map((live, index) => (
              <Col key={index.toString()} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mt={{ m: 30 }}>
                <LivesCard live={live} productClassUuid={productClassUuid} enrolled={enrolled} />
              </Col>
            ))}
          </Row>
        ) : (
          <Flex mt={30}>
            <Typography type="type5" color="alert_400" fontWeight="bold">
              Nenhuma live foi encontrada.
            </Typography>
          </Flex>
        )}
      </Section>
    </Flex>
  );
};

export default LivesList;

// import React, { ReactElement } from 'react';

// import { ProductsModulesCard, ProductsModuleCardState } from 'features/products';
// import { Col, Flex, Row, Typography, Section } from 'components';

// interface ProductsListProps {
//   modules: ProductsModuleCardState[];
// }

// const ProductsModulesList = ({ modules }: ProductsListProps): ReactElement => {
//   return (

//   );
// };

// export default ProductsModulesList;
